import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useEffect, useState } from 'react'

import useHomepage from '../../hooks/useHomepage'
import CloseMenuImage from '../../images/dropdown-close.svg'
import DropdownImage from '../../images/dropdown-menu.svg'
import WhiteCloseMenuImage from '../../images/white-dropdown-close.svg'
import WhiteDropdownImage from '../../images/white-dropdown-menu.svg'
import UtmContent from '../../models/UtmContent'
import { UrlService } from '../../services'

const DropdownMenu = () => {
  const [navbarOpen, setNavbarOpen] = useState(false)
  const [url, setUrl] = useState('')
  const { t } = useTranslation()
  const { productOffering, onPartnerPage, isGreenPage, landingPageAlias } = useHomepage()

  useEffect(() => {
    const utmContent = new UtmContent({
      position: landingPageAlias === 'nydinner' ? `${landingPageAlias}-login` : `${productOffering}-login`,
    }).toString()

    if (onPartnerPage) {
      setUrl(UrlService.restaurantLoginUrl())
    } else {
      setUrl(UrlService.loginUrl(utmContent))
    }
  })

  const handleToggle = () => {
    setNavbarOpen(!navbarOpen)
  }

  const dropdownIcon = (
    <img src={`${isGreenPage ? WhiteDropdownImage : DropdownImage}`} className="header__menu" onClick={handleToggle} />
  )
  const closeIcon = (
    <img
      src={`${isGreenPage ? WhiteCloseMenuImage : CloseMenuImage}`}
      className="header__exit"
      onClick={handleToggle}
    />
  )

  return (
    <>
      <nav className="header__navigation">
        {navbarOpen ? closeIcon : dropdownIcon}
        {navbarOpen && (
          <div>
            <ul>
              <li>
                <a href={url} onClick={handleToggle}>
                  {t('Log in')}
                </a>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </>
  )
}

export default DropdownMenu
